/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  AddressDto,
  BaseOrganizationDTO,
  CreateOrganizationPartnershipRequest,
  CreateOrganizationRequest,
  GetOrganizationAddressesParams,
  OrganizationDTO,
  OrganizationPartnershipDTO,
  SearchRequest,
  SearchResultOfOrganizationDTO,
  SearchResultOfOrganizationPartnershipDTO,
  UpdateOrganizationPartnershipRequest,
  UpdateOrganizationRequest
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Create an organization.
 * @summary Create Organization.
 */
export const createOrganization = (
    createOrganizationRequest: CreateOrganizationRequest,
 options?: SecondParameter<typeof apiRequest<OrganizationDTO>>,) => {
      return apiRequest<OrganizationDTO>(
      {url: `/organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationRequest
    },
      options);
    }
  /**
 * Get all organizations. Only for Super Admin users.
 * @summary Get Organizations.
 */
export const getOrganizations = (

 options?: SecondParameter<typeof apiRequest<OrganizationDTO[]>>,) => {
      return apiRequest<OrganizationDTO[]>(
      {url: `/organizations`, method: 'GET'
    },
      options);
    }
  /**
 * Update an organization.
 * @summary Update Organization.
 */
export const updateOrganization = (
    updateOrganizationRequest: UpdateOrganizationRequest,
 options?: SecondParameter<typeof apiRequest<OrganizationDTO>>,) => {
      return apiRequest<OrganizationDTO>(
      {url: `/organizations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationRequest
    },
      options);
    }
  /**
 * Create a partnership between two organizations.
 * @summary Creates Organization Partnership.
 */
export const createOrganizationPartnership = (
    createOrganizationPartnershipRequest: CreateOrganizationPartnershipRequest,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/organizations/partners`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationPartnershipRequest
    },
      options);
    }
  /**
 * Update an organization partnership.
 * @summary Update Organization Partnership.
 */
export const updateOrganizationPartnership = (
    updateOrganizationPartnershipRequest: UpdateOrganizationPartnershipRequest,
 options?: SecondParameter<typeof apiRequest<OrganizationPartnershipDTO>>,) => {
      return apiRequest<OrganizationPartnershipDTO>(
      {url: `/organizations/partners`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationPartnershipRequest
    },
      options);
    }
  /**
 * Search organizations.
 * @summary Search Organizations.
 */
export const searchOrganizations = (
    searchRequest: SearchRequest,
 options?: SecondParameter<typeof apiRequest<SearchResultOfOrganizationDTO>>,) => {
      return apiRequest<SearchResultOfOrganizationDTO>(
      {url: `/organizations/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchRequest
    },
      options);
    }
  /**
 * Get an organization.
 * @summary Get Organization.
 */
export const getOrganization = (
    organizationID: string,
 options?: SecondParameter<typeof apiRequest<OrganizationDTO>>,) => {
      return apiRequest<OrganizationDTO>(
      {url: `/organizations/${organizationID}`, method: 'GET'
    },
      options);
    }
  /**
 * Get all addresses in an organization.
 * @summary Get Addresses.
 */
export const getOrganizationAddresses = (
    organizationID: string,
    params?: GetOrganizationAddressesParams,
 options?: SecondParameter<typeof apiRequest<AddressDto[]>>,) => {
      return apiRequest<AddressDto[]>(
      {url: `/organizations/${organizationID}/addresses`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Search for organization partners.
 * @summary Search Partners.
 */
export const searchOrganizationPartners = (
    organizationID: string,
    searchRequest: SearchRequest,
 options?: SecondParameter<typeof apiRequest<SearchResultOfOrganizationPartnershipDTO>>,) => {
      return apiRequest<SearchResultOfOrganizationPartnershipDTO>(
      {url: `/organizations/${organizationID}/partners/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchRequest
    },
      options);
    }
  /**
 * Get all partner organizations of an organization.
 * @summary Get Partners.
 */
export const getOrganizationPartners = (
    organizationID: string,
 options?: SecondParameter<typeof apiRequest<BaseOrganizationDTO[]>>,) => {
      return apiRequest<BaseOrganizationDTO[]>(
      {url: `/organizations/${organizationID}/partners`, method: 'GET'
    },
      options);
    }
  /**
 * Get the partnership between two organizations, including its settings.
 * @summary Get Partnership.
 */
export const getOrganizationPartnership = (
    organizationID: string,
    partnerOrganizationID: string,
 options?: SecondParameter<typeof apiRequest<OrganizationPartnershipDTO>>,) => {
      return apiRequest<OrganizationPartnershipDTO>(
      {url: `/organizations/${organizationID}/partners/${partnerOrganizationID}`, method: 'GET'
    },
      options);
    }
  export type CreateOrganizationResult = NonNullable<Awaited<ReturnType<typeof createOrganization>>>
export type GetOrganizationsResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>
export type UpdateOrganizationResult = NonNullable<Awaited<ReturnType<typeof updateOrganization>>>
export type CreateOrganizationPartnershipResult = NonNullable<Awaited<ReturnType<typeof createOrganizationPartnership>>>
export type UpdateOrganizationPartnershipResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationPartnership>>>
export type SearchOrganizationsResult = NonNullable<Awaited<ReturnType<typeof searchOrganizations>>>
export type GetOrganizationResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationAddressesResult = NonNullable<Awaited<ReturnType<typeof getOrganizationAddresses>>>
export type SearchOrganizationPartnersResult = NonNullable<Awaited<ReturnType<typeof searchOrganizationPartners>>>
export type GetOrganizationPartnersResult = NonNullable<Awaited<ReturnType<typeof getOrganizationPartners>>>
export type GetOrganizationPartnershipResult = NonNullable<Awaited<ReturnType<typeof getOrganizationPartnership>>>
